






















































































































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import VWidget from '@/components/VWidget.vue';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import Figure from '@/store/entities/casis/figure';
import DealerList from './dealer-list.vue';

class PageFigureRequest {
    year: any = parseInt(Util.abp.clock.today().substr(0, 4));
    month: any = parseInt(Util.abp.clock.today().substr(5, 2));
    dealer: number = null;
    //red: number = null;
}

@Component({
    components: { VWidget, DealerList },
    watch: {
        dealer: function (val) {
            (this as any).loadData();
        },
        //red: function (val) {
        //    (this as any).loadData();
        //}
    }
})

export default class FigureForm extends ListBase {
    pagerequest: PageFigureRequest = new PageFigureRequest();
    changed: boolean = false;
    listValues: Array<any> = new Array<any>();
    totals: Array<any> = new Array<any>();
    showDealers: boolean = false;
    widType: string = 'Actualizados';
    dates: Array<any> = ['2018-09-15', '2018-09-20'];
    
    /***** computed methods *****/
    get widgets() {
        let sales = this.$store.state.dashboard.figures2;
        let months = this.gCommonList('months');
        return [
            { value: (sales[0] != undefined ? sales[0] : '0'), name: 'Actualizados', icon: 'directions_car', desc: 'Cifras aun no publicadas', onclick: this.openDealer },
            { value: (sales[1] != undefined ? sales[1] : '0'), name: 'Publicados', icon: 'airport_shuttle', desc: 'Cifras Publicadas', onclick: this.openDealer },
            { value: (sales[2] != undefined ? sales[2] : '0'), name: 'Pendientes', icon: 'pending', desc: 'Aun no cargaron sus datos', onclick: this.openDealer },
            //{ value: (sales[3] != undefined ? sales[3] : 'Fecha'), name: 'Plazo Entrega', icon: 'schedule', desc: months[(this.pagerequest as any).month - 1].name, onclick: null },
        ];
    }

    get loading() {
        return this.$store.state.figure.loading;
    }

    get list() {
        return this.$store.state.figure.list;
    }

    get periods() {
        return this.gCommonList('years');
    }

    get months() {
        let list = this.gCommonList('months');
        list.forEach(m => {
            m['field'] = 'month_' + m.id;
        });
        return list;
    }

    get figureMonths() {
        let list = [];
        this.$store.state.figure.activeList.forEach(m => {
            list[m.month] = m;
        });
        return list;
    }

    get groups() {
        let list = Util.abp.list.getList('G_FIGURE');
        list.forEach(item => {
            if (item.code == 'TA') item.subtotal = 4;
            if (item.code == 'VE') item.subtotal = 9;
            if (item.code == 'IN') item.subtotal = 21;
            if (item.code == 'HO') item.subtotal = 26;
        });
        
        return list;
    }

    get dealer() {
        return this.$store.state.app.dealers;
    }
           
    //get red() {
    //    return this.$store.state.app.red;
    //}

    get figure() {
        if (this.list[0] == undefined) return null;
        if (this.list[0].figure_id == null) return null;
        return {
            id: this.list[0].figure_id,
            month: this.list[0].figure_month,
            state: this.list[0].figure_state,
            published: this.list[0].figure_published,
        };
    }

    get lastMonth() {
        if (this.figure == null) return this.months[0];

        return this.months[this.figure.month - 1];
    }

    get nextMonth() {
        if (this.figure == null) return this.months[0];

        let month = this.figure.month - 1;
        if (this.figure.published && month <= 10) month++;
        return this.months[month];
    }

    get state() {
        if (this.figure == null) return Util.abp.list.get('E_FIGURE','DI');
        return Util.abp.list.getItem(this.figure.state);
    }

    get checking() {
        return this.$store.state.dashboard.loading;
    }

    get isAdmin() {
        return Util.abp.session.isAdmin;
    }

    get statePU() {
        return Util.abp.list.get('E_FIGURE', 'PU').id;
    }

    get isDealer() {
        return Util.abp.session.isDealer();
    }

    get monthDates() {
        let months = this.gCommonList('months');
        let dates = this.$store.state.auditlog.dates;
        let list = [];
        months.forEach(m => {
            let item = { month: m.id, dates: [] };
            item.dates.push(...dates.filter(a => { return a.month == m.id }).map(a => { return a.date }));
            if (item.dates.length > 0)
                list.push(item);
        });
        return list;
    }

    /***** fields events *****/
    columns(group: string) {
        let cols = [{ value: 'concept_name', text: group.toUpperCase(), type: 'text', sortable: false, align: 'start', width: '280px', class: '' }];

        this.months.forEach(m => {
            let cClass = (this.figure != null && m.field == ('month_' + this.figure.month) ? 'selected-month' : '');
            if (this.figure != null && this.figure.published && this.figure.month == 12) cClass = '';
            cols.push({ value: m.field, text: m.name, type: 'text', width: '82px', sortable: false, align: 'center', class: cClass });
        });
        cols.push({ value: 'total', text: 'TOTAL', type: 'text', width: '65px', sortable: false, align: 'center', class: '' });
        return cols;
    }
    
    setList() {
        this.listValues = [];
        this.groups.forEach(gru => {
            let subTotal = { concept_name: 'Sub Total', number: null, total: 0 };

            this.listValues[gru.id] = [];

            this.list.forEach(item => {
                if (item.group_id == gru.id) {
                    this.listValues[gru.id].push(item);

                    if (subTotal != null && item.number <= gru.subtotal) {
                        this.months.forEach(m => {
                            if (subTotal[m.field] == undefined && item[m.field] != undefined) subTotal[m.field] = 0;
                            if (item[m.field] != undefined) {
                                subTotal[m.field] += item[m.field];
                                subTotal.total += item[m.field];
                            }
                        });

                        if (subTotal != null && item.number == gru.subtotal)
                            this.listValues[gru.id].push(subTotal);
                    }
                }
            });
        });            
    }

    updateTotal(item) {
        this.changed = true;
        item.total = 0;
        this.months.forEach(m => {
            item.total += (item[m.field] == null || item[m.field] == '' ? 0 : parseFloat(item[m.field]));
        });
        this.setTotals();
    }

    setTotals() {
        this.totals = [];
        this.groups.forEach(gru => {
            this.totals[gru.id] = {total: 0};

            this.months.forEach(m => {
                this.totals[gru.id][m.field] = 0;
            });

            if (this.listValues[gru.id] != undefined) {
                this.listValues[gru.id].forEach(item => {
                    this.months.forEach(m => {
                        if (item.number != null)
                            this.totals[gru.id][m.field] += parseFloat((item[m.field] != undefined && item[m.field] != '' ? item[m.field] : 0));
                    });
                });

                this.months.forEach(m => {
                    this.totals[gru.id][m.field] = parseFloat(this.totals[gru.id][m.field].toFixed(2));
                    this.totals[gru.id].total += this.totals[gru.id][m.field];
                });
            }

            this.totals[gru.id].total = parseFloat(this.totals[gru.id].total.toFixed(2));
        });
    }

    getInitials(string) {
        return Util.getInitials(string);
    }

    onFocus(e) {
        e.target.select();
    }

    openDealer(item) {
        this.widType = item.name;
        this.showDealers = true;
    }

    async exportData() {
        this.pagerequest.dealer = this.dealer;
        //this.pagerequest.red = this.red;
        let filename = await this.$store.dispatch({
            type: 'figure/export',
            data: this.pagerequest
        });
        if (filename != '' && filename != undefined)
            window.location = filename;
    }

    async create() {
        if (this.dealer.length == 1) {
            let dealer = this.dealer[0];
            await this.$store.dispatch({
                type: 'figure/create',
                data: {
                    dealer_id: dealer,
                    year: this.pagerequest.year,
                    month: this.nextMonth.id
                }
            });
            await this.loadData();
        }
    }

    async save(publish = false) {
        if (this.figure != null) {
            let model = Util.extend(true, {}, this.figure);
            model.concepts = [];

            if (publish)
                model.state = Util.abp.list.get('E_FIGURE', 'PU').id;

            this.list.forEach(item => {
                model.concepts.push({
                    figure_id: item.figure_id,
                    concept_id: item.concept_id,
                    year: item.year,
                    month: item.figure_month,
                    amount: item['month_' + item.figure_month],
                });
            });

            await this.$store.dispatch({
                type: 'figure/update',
                data: model
            });
            await this.loadData();
        }
    }

    async saveAmount(item) {
        if (item != null && this.dealer.length == 1) {
            item.dealer_id = this.dealer[0];
            await this.$store.dispatch({
                type: 'figure/updateConcept',
                data: item
            });
        }
    }

    async loadData() {
        this.pagerequest.dealer = this.dealer;
        //this.pagerequest.red = this.red;
        await this.$store.dispatch({
            type: 'figure/getAll',
            data: this.pagerequest
        });
        this.setList();
        this.setTotals();
        //this.loadWidgets();
        this.loadDates();
    }

    async loadWidgets() {
        //if (!this.isDealer)
        //    await this.$store.dispatch({
        //        type: 'dashboard/getWidgetFigures',
        //        data: this.pagerequest
        //    });
    }

    async loadDates() {
        this.$store.commit('auditlog/setDates', []);
        await this.$store.dispatch({
            type: 'auditlog/getDatesByMonth',
            data: {
                year: this.pagerequest.year,
                dealers: this.dealer,
                model: 'figures',
            }
        });
            
    }

    async enableFigure(item) {
        await this.$store.dispatch({
            type: 'figure/enable',
            data: {
                id: item.id,
                dealer: this.dealer,
                year: this.pagerequest.year,
                month: item.month,
            }
        });

        await this.loadData();
    }

    async confirmFigure(item) {
        await this.$store.dispatch({
            type: 'figure/confirm',
            data: {
                id: item.id,
                dealer: this.dealer,
                year: this.pagerequest.year,
                month: item.month,
            }
        });
        await this.loadData();
    }
           
    async processApiCasis() {
        await this.$store.dispatch({
            type: 'figure/processApiCasis',
            data: { year: this.pagerequest.year, month: this.pagerequest.month}
        });
        await this.loadData();
    }

    async mounted() {
        await this.loadData();
        //await this.loadWidgets();
    }

    async created() {
    }
}
